// extracted by mini-css-extract-plugin
export var column = "M_b8";
export var container = "M_b";
export var icon = "M_bw";
export var link = "M_bs";
export var title = "M_g";